module.exports = __webpack_public_path__ + "static/img/icon1.ef580b13.svg";